import { connect } from 'react-redux';

import CheckMark from '@o2/icons/CheckMark';
import Block from '@o2/icons/Block';

import { green, red } from '@mui/material/colors';

import { styled } from '@mui/material/styles';
import Box from '@o2/ui/Box';

import Button from '@o2/ui/Button';
import Typography from '@o2/ui/Typography';

import { useTranslationWithDataKey } from 'hooks/useTranslationWithDataKey';
import Modal from 'views/components/Modal/Modal';

const ModalContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: 'rgb(237, 239, 246)',

  [theme.breakpoints.down('sm')]: {
    padding: `${theme.spacing(4)} ${theme.spacing(2.5)}`,
  },
}));

const ButtonsWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

interface Props {
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const CustomerRequestConfirmationDialog = ({ isOpen, onConfirm, onClose }: Props) => {
  const { t } = useTranslationWithDataKey();

  return (
    <Modal open={isOpen} onClose={onClose} sx={{ zIndex: '999999' }}>
      <ModalContent>
        <Box>
          <Typography variant="h4" align="center">
            {t('gui_requirementManagement.crCreation.text.PZPanelCloseConfirmation')}
          </Typography>
        </Box>
        <ButtonsWrapper>
          <Button variant="text" onClick={onConfirm} startIcon={<CheckMark sx={{ color: green[500] }} />}>
            {t('gui_requirementManagement.crCreation.ClosePanelButton')}
          </Button>
          <Button variant="text" onClick={onClose} startIcon={<Block sx={{ color: red[500] }} />}>
            {t('gui_requirementManagement.crCreation.NoClosePanelButton')}
          </Button>
        </ButtonsWrapper>
      </ModalContent>
    </Modal>
  );
};

export default connect(null, null)(CustomerRequestConfirmationDialog);
